import React from "react";
import classNames from "classnames";
import { Checkbox, Switch } from "antd";
import WeaHelpfulTip from "../wea-helpful-tip";
import WeaLocaleProvider from "../wea-locale-provider";
import middleware from "../../middleware";

const { formatMultiLang } = WeaLocaleProvider;

class main extends React.Component {
  static defaultProps = {
    display: "normal",
    className: ""
  };
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : "0"
    };
  }
  componentWillReceiveProps(nextProps, nextState) {
    if ("value" in nextProps) {
      this.setState({ value: nextProps.value });
    }
  }
  doChange(e) {
    let value;
    if (this.props.display == "switch") {
      value = e ? "1" : "0";
    } else {
      value = e.target.checked ? "1" : "0";
    }
    this.setState({ value });
    this.props.onChange && this.props.onChange(value);
  }

  render() {
    const {
      viewAttr,
      fieldName,
      display,
      content,
      disabled,
      ecId,
      helpfulTip,
      helpfulTipProps,
      className
    } = this.props;
    const { value } = this.state;
    const req = classNames({
      [`${className}`]: className,
      required: viewAttr == "3" && value !== "1" && value !== "0"
    });
    if (display == "switch") {
      return (
        <div
          ecId={`${ecId}_div@4vpzoe`}
          className={`wea-switch ${req}`}
          style={{
            width: 32,
            height: 25,
            ...this.props.style,
            position: "relative"
          }}
        >
          <Switch
            ecId={`${ecId}_Switch@zagisu`}
            disabled={viewAttr == 1 || disabled}
            checked={value == "1"}
            onChange={this.doChange.bind(this)}
          />
          <input type="hidden" id={fieldName} name={fieldName} value={value} />
          {helpfulTip && (
            <WeaHelpfulTip
              ecId={`${ecId}_WeaHelpfulTip@ep8j08`}
              style={{ position: "absolute", right: -31, top: 0 }}
              title={helpfulTip}
              {...helpfulTipProps}
            />
          )}
          {this.props.children}
        </div>
      );
    }
    return (
      <div
        className={`wea-checkbox ${className}`}
        style={this.props.style}
        ecId={`${ecId}_div@mo4ny1`}
      >
        <Checkbox
          ecId={`${ecId}_Checkbox@8rcnct`}
          disabled={viewAttr == 1 || disabled}
          checked={value == "1"}
          indeterminate={value == "2"}
          onChange={this.doChange.bind(this)}
          className="content"
        >
          {content ? formatMultiLang(content) : null}
        </Checkbox>
        <input type="hidden" id={fieldName} name={fieldName} value={value} />
        {viewAttr == "3" && value !== "1" && value !== "0" && (
          <span className="wea-required-e9">
            <img
              src={`${window.ecologyContentPath ||
                ""}/images/BacoError_wev9.png`}
              align="middle"
            />
          </span>
        )}
        {helpfulTip && (
          <WeaHelpfulTip
            ecId={`${ecId}_WeaHelpfulTip@g027eb`}
            style={{ position: "absolute", right: -31, top: 0 }}
            title={helpfulTip}
            {...helpfulTipProps}
          />
        )}
        {this.props.children}
      </div>
    );
  }
}
const Com = middleware(main, "WeaCheckbox");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-checkbox/index.js